import { render } from "./usaClients.vue?vue&type=template&id=9b388b08"
import script from "./usaClients.vue?vue&type=script&lang=js"
export * from "./usaClients.vue?vue&type=script&lang=js"

import "./usaClients.vue?vue&type=style&index=0&id=9b388b08&lang=css"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__